import styled, { keyframes } from 'styled-components';

const checkIn = keyframes`
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
`;

// ===== FORM =====

export const FormGroup = styled.div`
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
`;

export const FormLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.45);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 8px;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1px solid ${props => props.$hasError ? 'rgba(255, 107, 107, 0.5)' : 'rgba(255, 255, 255, 0.1)'};
  background: rgba(255, 255, 255, 0.03);
  color: #FFFFFF;
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  outline: none;
  transition: all 0.25s ease;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(255, 255, 255, 0.2);
  }

  &:focus {
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.05);
  }

  @media (max-width: 768px) {
    padding: 14px 16px;
    font-size: 0.95rem;
  }
`;

export const FormError = styled.span`
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: rgba(255, 107, 107, 0.85);
  margin-top: 6px;
  font-weight: 300;
`;

// ===== CONFIRMATION =====

export const ConfirmationIcon = styled.div`
  width: 56px;
  height: 56px;
  margin-bottom: 28px;
  color: #8AACC8;
  animation: ${checkIn} 0.5s cubic-bezier(0.25, 0.1, 0.25, 1) both;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Divider = styled.div`
  width: 60px;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 8px 0 32px;
`;

// ===== SCHEDULE =====

export const ScheduleWrapper = styled.div`
  width: 100%;
  max-width: 480px;
`;

export const ScheduleTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.45);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 16px;
  text-align: center;
`;

export const ScheduleGrid = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;

  /* Scrollbar sutil */
  &::-webkit-scrollbar { height: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.1); border-radius: 4px; }
`;

export const DayColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 72px;
  flex: 1;
`;

export const DayLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 4px;

  span:first-child {
    font-family: 'Inter', sans-serif;
    font-size: 0.7rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.35);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  span:last-child {
    font-family: 'Inter', sans-serif;
    font-size: 0.78rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
  }
`;

export const TimeSlot = styled.button`
  padding: 10px 6px;
  border-radius: 6px;
  border: 1px solid ${props => props.$selected ? 'rgba(255, 255, 255, 0.35)' : 'rgba(255, 255, 255, 0.06)'};
  background: ${props => props.$selected ? 'rgba(255, 255, 255, 0.08)' : 'transparent'};
  color: ${props => props.$selected ? '#FFFFFF' : 'rgba(255, 255, 255, 0.5)'};
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  font-weight: ${props => props.$selected ? '500' : '400'};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.8);
  }
`;
